import { Badge, Tab, Tabs } from "@mui/material";
import React from "react";

interface IDialogTab {
  id: string;
  title: string;
  badgeContent?: number;
  disabled?: boolean;
  hidden?: boolean;
}

interface IPageTabsProps {
  activeTabId: string;
  tabs: IDialogTab[];
  onChangeTab: (tabId: string) => void;
}

export const DialogTabs = ({
    activeTabId,
    tabs,
    onChangeTab,
}: IPageTabsProps) => {
    const handleChangeViewTab = (
        _event: React.SyntheticEvent,
        newValue: string
    ) => {
        onChangeTab(newValue);
    };

    return (
        <Tabs value={activeTabId} onChange={handleChangeViewTab}>
            {tabs.map(
                (tab) =>
                    !tab.hidden && (
                        <Tab
                            key={tab.id}
                            label={
                                tab.badgeContent > 0
                                    ? (
                                        <Badge
                                            color="info"
                                            badgeContent={tab.badgeContent}
                                            sx={{
                                                "span": {
                                                    top: "-3px",
                                                    right: "-4px",
                                                }
                                            }}
                                        >
                                            {tab.title}
                                        </Badge>
                                    )
                                    : (
                                        tab.title
                                    )
                            }
                            value={tab.id}
                            disabled={tab.disabled}
                        />
                    )
            )}
        </Tabs>
    );
};